import React, { ReactElement, useState, useEffect } from 'react';
import { Modal, Button, Radio } from 'antd';

interface PolicyHistoryMeModalProps {
  modalFn;
}

function ChangePolicyMeModal(props: PolicyHistoryMeModalProps): ReactElement {
  const { modalFn } = props;
  const { visible, closeModal, melPolicy, welfareName, changePolicy } = modalFn;
  const { name } = melPolicy;

  const [value, setValue] = useState(undefined);

  useEffect(() => {
    if (melPolicy) {
      setValue(melPolicy.isactive);
    }
  }, [melPolicy]);

  const onChange = (v) => {
    setValue(v.target.value);
  };

  const changeWelfarePolicy = async () => {
    const params = {
      isactive: value
    };
    await changePolicy(melPolicy.idx, params);
    await closeModal();
  };

  return (
    <Modal
      title="복지정책 변경"
      visible={visible}
      onCancel={closeModal}
      width={1000}
      closable
      footer={[
        <div key="footer">
          <span style={{ float: 'left' }}>완료를 누르시면 복지 정책이 지금 바로 변경됩니다.</span>
          <Button key="closeBtn" onClick={closeModal}>
            닫기
          </Button>
          <Button type="primary" key="suBtn" onClick={changeWelfarePolicy}>
            완료
          </Button>
        </div>
      ]}
    >
      {melPolicy && <div>{`${welfareName} > ${name}`}</div>}
      <span>상태: </span>
      <Radio.Group onChange={onChange} value={value}>
        <Radio value>활성</Radio>
        <Radio value={false}>비활성</Radio>
      </Radio.Group>
    </Modal>
  );
}

export default ChangePolicyMeModal;
